//Component Imports
import Header from "../Global/header";
import Footer from "../Global/footer";
import Terms from "./terms";

export default function TermsPage() {
  return (
    <main>
      <Header />
      <Terms />
      <Footer />
    </main>
  );
}
